/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from '../../../../components/Containers/ArgosFlexbox';
import { ReportsTable } from '../common/ReportsTable';


/** Name to display in horizontal tabs component */
export const SENSOR_COMPONENT_REQUIREMENTS_NAME = 'Sensor Component Requirements'

/**
 * This tab allows user to create, update, and view the Sensor Component
 * Requirement reports for the ADAS Program.
 */
export const SensorComponentRequirements = () => {
  return (
    <ArgosFlexbox vertical style={{height: '100%', width: '100%'}}>
      <ReportsTable />
    </ArgosFlexbox>
  )
}
